/**
 * Composition root - wires together core domain with infrastructure and UI
 */

import { DropboxStorage } from './infrastructure/dropbox-storage.js';
import { LocalSelectionStorage } from './infrastructure/local-selection-storage.js';
import { WebUI } from './ui/web-ui.js';
import { PhotoService } from './core/photo-service.js';
import { SelectionService } from './core/selection-service.js';

/**
 * Folder to scan for photos (can be made configurable later)
 */
const PHOTOS_FOLDER = '/Pictures';

/**
 * Dropbox OAuth configuration
 * CLIENT_ID is public and safe to include in client-side code
 */
const DROPBOX_CLIENT_ID = 'izdftanjg4bhx83';

/**
 * Main application entry point
 */
async function main() {
  // Try to create storage (handles OAuth PKCE flow internally)
  const storage = await DropboxStorage.create({
    clientId: DROPBOX_CLIENT_ID,
    folderPath: PHOTOS_FOLDER
  });

  if (!storage) {
    // Need authentication - show prompt
    await showAuthPrompt();
    return;
  }

  const photoService = new PhotoService(storage);

  // Create selection service with localStorage persistence
  const selectionStorage = new LocalSelectionStorage();
  const selectionService = new SelectionService(selectionStorage);

  const container = document.getElementById('app');
  if (!container) {
    throw new Error('App container not found');
  }

  const ui = new WebUI({
    containerElement: container,
    photoService,
    selectionService
  });

  // Load and display photos
  await ui.loadPhotos();
}

/**
 * Show Dropbox OAuth prompt
 */
async function showAuthPrompt() {
  const container = document.getElementById('app');
  if (!container) return;

  const authUrl = await DropboxStorage.getAuthUrl(DROPBOX_CLIENT_ID);

  const prompt = document.createElement('div');
  prompt.className = 'auth-prompt';

  const h1 = document.createElement('h1');
  h1.textContent = 'Photo Library';

  const p = document.createElement('p');
  p.textContent = 'This app needs access to your Dropbox to display photos.';

  const link = document.createElement('a');
  link.href = authUrl;
  link.className = 'auth-button';
  link.textContent = 'Connect to Dropbox';

  prompt.appendChild(h1);
  prompt.appendChild(p);
  prompt.appendChild(link);

  container.innerHTML = '';
  container.appendChild(prompt);
}

// Start the app
main().catch(console.error);
